import { CustomerProjectTypeModelType } from '@teinor/erp/types/company/customer/customerProjectType'
import { LittleModalCreateEdit } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getAllCustomerProjectTypes, getAllTaskTypes } from '../../../../../../../utils/reducers/getters'
import useCustomerTypesRandomColor from '../../../../../../../utils/hooks/customer/useCustomerTypesRandomColor'
import { useMemo } from 'react'
import { addDictionaryExtraLine } from '../../../../../../../utils/globals/dictionary'
import { emptyExtraLineFirstSortFunction } from '../../../../../../../forms/CustomSelect/functions'
import { connect, ConnectedProps } from 'react-redux'
import { TChecklistsPayload } from '../../../../../../../utils/reducers/customers/tChecklists'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import withLoading from '../../../../../../../utils/hoc/withLoading'

type ModalCECustomerProjectTypeProps = & ReduxCustomerProject & ModalEditComponentProps & { }

const ModalCECustomerProjectType: React.FC<ModalCECustomerProjectTypeProps> = ({ userPermissions, allRowData, tChecklists, ...rest }) => {
    const { t } = useTwinTranslation()
    const { getDefaultRandomColorCustomerTypes } = useCustomerTypesRandomColor()
    const myCustomerProjectTypes = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(getAllCustomerProjectTypes())) || {}), [])
    const checkListExtraLineDict = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(tChecklists || {}))), [tChecklists])
    const MyTCheckistId = useMemo(() => Object.values(tChecklists)?.[0]?.id, [tChecklists])
    const fields: FormRender<CustomerProjectTypeModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                },
                {
                    name: 'TaskTypeId',
                    component: 'CustomSelect',
                    label: t('taskType', 'Tipo de tarea'),
                    items: getAllTaskTypes() || {},
                },
                {
                    name: 'color',
                    label: t('color', 'Color'),
                    component: 'InputColorWithMargin',
                    defaultValue: allRowData?.color || getDefaultRandomColorCustomerTypes()
                },
                {
                    name: 'CustomerPTForProjectId',
                    component: 'CustomSelectSearchBarWithNotInFilteredItems',
                    label: t('useProjectStatsFrom', 'Utilizar estados de proyecto de:'),
                    items: myCustomerProjectTypes,
                    excludeItems: [allRowData?.id],
                    sortItems: true,
                    sortFunction: emptyExtraLineFirstSortFunction
                },
                {
                    name: 'CustomerPTForOpportunityId',
                    component: 'CustomSelectSearchBarWithNotInFilteredItems',
                    label: t('useOpportunityStatsFrom', 'Utilizar estados de oportunidades de:'),
                    items: myCustomerProjectTypes,
                    excludeItems: [allRowData?.id],
                    sortItems: true,
                    sortFunction: emptyExtraLineFirstSortFunction
                },
                {
                    name: 'CPChecklistId',
                    component: 'CustomSelectWithSearchBar',
                    label: t('defaultList', 'Lista por defecto'),
                    items: checkListExtraLineDict || {},
                    value: !allRowData ? (MyTCheckistId || '') : allRowData?.CPChecklistId, 
                    sortFunction: emptyExtraLineFirstSortFunction,
                },
                {
                    name: 'is_project_main',
                    label: t('projectMain', 'Principal para proyecto'),
                    component: 'CheckboxMargin',
                    defaultChecked: allRowData?.is_project_main
                },
                {
                    name: 'is_opportunity_main',
                    label: t('OppMain', 'Principal para oportunidad'),
                    component: 'CheckboxMargin',
                    defaultChecked: allRowData?.is_opportunity_main
                }
            ]
        },
    ]
    if (allRowData && userPermissions) {
        fields[0].elements.push({
            name: 'active',
            label: t('active', 'Activo'),
            component: 'CheckboxMargin'
        })
        fields[0].elements.push({
            label: t('photo', 'Foto'),
            name: 'photo',
            component: 'ImageInput',
        })
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<LittleModalCreateEdit imagePath={['customerProjectType', allRowData?.id]} fields={parsedFields} url={'/api/app/customer/customerProject/customerProjectTypes/updateCustomerProjectType'} translations={{ title: t('editCustomerProjectType', 'Editar tipo de proyecto'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest}></LittleModalCreateEdit>)
    }
    return (<LittleModalCreateEdit fields={fields} url={'/api/app/customer/customerProject/customerProjectTypes/createCustomerProjectType'} translations={{
        title: t('createCustomerProjectType', 'Crear tipo de proyecto'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}

const customerProjectDispatch = {
    setTChecklists: (payload: TChecklistsPayload) => ({ type: 'CHANGE_T_CHECKLISTS', payload })
}

export type ReduxCustomerProject = ConnectedProps<typeof customerProjectConnect>
const mapCustomerProjectTypesConnector = (state: AllReduxPayloads) => ({ tChecklists: state.tChecklists })
const customerProjectConnect = connect(mapCustomerProjectTypesConnector, customerProjectDispatch)

const customerProjectConnectLoading = withLoading(ModalCECustomerProjectType, [{ fetchUrl: '/api/app/config/templateChecklist/getAllTChecklists', propName: 'tChecklists', setFunctionName: 'setTChecklists' }])

const ModalCECustomerProjectTypeConnect = customerProjectConnect(customerProjectConnectLoading)

export default ModalCECustomerProjectTypeConnect